import React from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import "videojs-youtube";

export const VideoJS = (props) => {
    const placeholderRef = React.useRef(null);
    const playerReference = React.useRef(null);
    const {options, onReady} = props;


    React.useEffect(() => {
        // Make sure Video.js player is only initialized once
        if (!playerReference.current) {
            const placeholderEl = placeholderRef.current;
            const videoElement = placeholderEl.appendChild(
                document.createElement("video-js")
            );

            const player = (playerReference.current = videojs(videoElement, options, () => {
                player.log("player is ready");
                onReady && onReady(player);
            }));

            // You can update player in the `else` block here, for example:
        } else {
            const player = playerReference.current;
            player.autoplay(options.autoplay);
            player.src(options.sources);
        }
    }, [options, onReady]);

    // Destroy video.js player on component unmount
    React.useEffect(() => {
        const player = playerReference.current;
        return () => {
            if (player) {
                player.dispose();
                playerReference.current = null;
            }
        };
    }, [playerReference]);
    // wrap player with data-vjs-player` attribute
    // so no additional wrapper are created in the DOM
    return <div
        ref={placeholderRef}
        style={{
            width: '100%',
            height:'auto'
    }}
    >
    </div>;
}
export default VideoJS;


